export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14941.d3ce8d54.jpg";